import axios from 'axios'
import { baseURL } from '@/config/.env-default.js'

// axios配置
const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
})

// request interceptor
instance.interceptors.request.use(
  (config) => {
    // config.headers.token = 'abcdefg123456'
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response interceptor
instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance

/**
 * 查询请求
 * @param {string} url url地址
 * @param {object} params url 参数
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * post 请求
 * @param {string} url 地址
 * @param {object} data 参数
 * @param {object} config 配置
 */
export function post(
  url,
  data = {},
  config = {
    transformRequest: [
      function (fData, headers) {
        headers['Content-Type'] = 'application/json'
        return JSON.stringify(fData)
      },
    ],
  }
) {
  return new Promise((resolve, reject) => {
    instance.post(url, data, config).then(
      (response) => {
        resolve(response.data)
      },
      (error) => {
        reject(error)
      }
    )
  })
}

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    instance
      .patch(url, data, {
        transformRequest: [
          function (fData, headers) {
            headers['Content-Type'] = 'application/json'
            return JSON.stringify(fData)
          },
        ],
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
  })
}

export function del(url, data) {
  return new Promise((resolve, reject) => {
    instance.delete(url, { data }).then(
      (response) => {
        resolve(response.data)
      },
      (error) => {
        reject(error)
      }
    )
  })
}

/**
 * put 请求
 * @param {string} url 地址
 * @param {object} data 参数
 * @param {object} config 配置
 */
export function put(
  url,
  data = {},
  config = {
    transformRequest: [
      function (fData, headers) {
        headers['Content-Type'] = 'application/json'
        return JSON.stringify(fData)
      },
    ],
  }
) {
  return new Promise((resolve, reject) => {
    instance.post(url, data, config).then(
      (response) => {
        resolve(response.data)
      },
      (error) => {
        reject(error)
      }
    )
  })
}
